import { Popover } from '@base-ui/react/popover'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface PopoverCloseProps extends PartProps<Popover.Close.Props> {
  className?: string
}

function PopoverClose({ className, children, ...props }: PopoverCloseProps) {
  return (
    <Popover.Close
      className={twMerge(
        'flex h-9 min-h-9 w-full cursor-pointer items-center gap-2.5 px-4 py-2 text-sm',
        'bg-element text-foreground hover:bg-element-hover',
        className,
      )}
      {...props}
    >
      {children}
    </Popover.Close>
  )
}

export { PopoverClose }
